<template>
    <button class="loader-button" v-on="$listeners">
        <template v-if="isLoading">
            <div class="spinner">
                <div class="bounce1"></div>
                <div class="bounce2"></div>
                <div class="bounce3"></div>
            </div>
        </template>
        <slot></slot>
    </button>
</template>

<script>
export default {
    name: 'LoaderButton',
    props: ['isLoading']
}
</script>

<style scoped>
    .spinner {
        display: inline-block;
        width: 40px;
        text-align: center;
    }

    .spinner > div {
        display: inline-block;
        width: 11px;
        height: 11px;
        background-color: #333;
        border-radius: 100%;
        animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    }

    .spinner .bounce1 {
        animation-delay: -0.32s;
    }

    .spinner .bounce2 {
        animation-delay: -0.16s;
    }

    @keyframes sk-bouncedelay {
        0%, 80%, 100% {
            transform: scale(0);
        }
        40% {
            transform: scale(1.0);
        }
    }
</style>
